/// <summary>
/// Auth : 정지효
/// Date : 2023/05/19
/// Desc : AI 시스템 로그인페이지
/// </summary>

import React, { useState, useEffect } from 'react';
import './Login.css';
import TextBox from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';
import { useNavigate } from 'react-router'
import ResponsiveBox, {
    Row,
    Col,
    Item,
    Location,
} from 'devextreme-react/responsive-box';
import Box from 'devextreme-react/box';
import { Cookies } from 'react-cookie';
import config from './Config.js';

const alertFail = () => {
    const elem = document.getElementById('vibrate');
    elem.classList.add("vibrating");
    elem.style.display = 'block';
    setTimeout(() => {
        elem.classList.remove("vibrating");
    }, 1000);
}

export default function Login() {

    const cookies = new Cookies();

    const authCheck = () => {
        const aspNetCookie = cookies.get(".AspNetCore.Cookies");
        if (aspNetCookie == undefined) {
            console.log("Login required.");
        }
        else {
            console.log("Success")
            navigate('/');
        }
    };

    useEffect(() => {
        authCheck();
    });

    const [id, setId] = useState('');
    const [password, setPassword] = useState('');

    const navigate = useNavigate();

    const handleIdChange = (e) => {
        setId(e.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Create an object with the credentials
        const credentials = {
            userid: id,
            password: password
        };

        // Send a POST request to the login endpoint
        fetch(`${config.apiUrl}/auth/login`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        })
            .then((res) => {
                if (res.ok) {
                    res.headers.forEach(function(val, key) { console.log('header:' + key + ' -> ' + val); });
                    return res.json();
                } else {
                    throw new Error('Login failed');
                }
            })
            .then((data) => {
                // Handle the successful response from the server
                console.log(data);
                navigate('/');
            })
            .catch((error) => {
                // Handle the error
                console.error('Error:', error);
                alertFail();

            });
    };

    return (
        <div id="box" style={{ height: '100vh', width: '100vw'}}>
            <ResponsiveBox>
                <Row ratio={1.5}></Row>
                <Row ratio={1}></Row>
                <Row ratio={1}></Row>

                <Col ratio={2}></Col>
                <Col ratio={1}></Col>
                <Col ratio={2}></Col>
                <Item>
                    <Location
                        row={1}
                        col={1}
                        screen="lg"
                    ></Location>
                    <Location
                        row={1}
                        col={0}
                        colspan={2}
                        screen="sm"
                    ></Location>
                    <div className="content item" style={{ padding: '15px', border: '2px solid #3cbab2' }}>
                        <form noValidate onSubmit={handleSubmit}>
                            <p style={{ fontSize: '20px', color: '#3cbab2', textAlign: 'center' }}> AI 해석 시스템 관리자 </p>
                        <Box
                            direction="col"
                            width="100%"
                            height={125}>
                            <Item ratio={1}>
                                <div>
                                        <TextBox
                                            label="아이디"
                                            name="id"
                                            variant="outlined"
                                            value={id}
                                            onValueChanged={handleIdChange}
                                            labelMode="floating"
                                        />
                                </div>
                            </Item>
                            <Item ratio={1}>
                                <div>
                                        <TextBox
                                            label="비밀번호"
                                            mode="password"
                                            name="pw"
                                            variant="outlined"
                                            value={password}
                                            onValueChanged={handlePasswordChange}
                                            labelMode="floating"
                                        />
                                </div>
                            </Item>
                            <Item ratio={1}>
                                    <div style={{ textAlign: 'center' } }>
                                        <Button
                                            width={120}
                                            text="로그인"
                                            type="default"
                                            stylingMode="contained"
                                            useSubmitBehavior={true}
                                        />
                                </div>
                            </Item>
                        </Box>
                        </form>
                        <p id="vibrate">아이디 또는 비밀번호를 잘못 입력했습니다.</p>
                    </div>
                </Item>
            </ResponsiveBox>
        </div>
        
    );
}
